// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"332":"65cc1447","354":"be8a2658","953":"975eab37"}[chunkId] + ".js";
};